/**
 * Work package ids.
 *
 * A fixed list rather than free text, because these ids are the join to the
 * project mindmaps: `WP-03` on a task is meant to be the same `WP-03` node in
 * the map, and a typo silently breaks that link.
 *
 * Nine is the ceiling because no project here has more. Widen the list if one
 * ever does; nothing else needs to change.
 */
export const WORK_PACKAGES = [
  "WP-01",
  "WP-02",
  "WP-03",
  "WP-04",
  "WP-05",
  "WP-06",
  "WP-07",
  "WP-08",
  "WP-09",
] as const;

/**
 * The options a picker should offer for a given current value.
 *
 * A task may already hold something outside the list — the sheet has values
 * like `WP6` from before this field existed. Those are kept as an extra option
 * so that opening a task and saving it cannot quietly erase one.
 */
export function workPackageOptions(current: string): string[] {
  const value = current.trim();
  const known: string[] = [...WORK_PACKAGES];
  if (value && !known.includes(value)) return [value, ...known];
  return known;
}
